import {TagProps} from 'antd';

import * as cssVariableStyles from '../../../../../../css/var-export.scss';
import {LangKeyType} from '../../../../../../provider/locale/translation/type';
import {AiMonitoringTonalityEnum} from '../../../../../../service/ai-brand-monitoring/ai-brand-monitoring-type';

// The two headline metrics keep one color each across the hero cards and the dynamics chart.
export const VISIBILITY_METRIC_COLOR = cssVariableStyles.orange60;
export const TONALITY_METRIC_COLOR = cssVariableStyles.green60;

// Both scores are percentages of a fixed 0..100 scale.
export const SCORE_MAX = 100;

export const TONALITY_LANG_KEY_MAP: Record<AiMonitoringTonalityEnum, LangKeyType> = {
    [AiMonitoringTonalityEnum.positive]: 'AI_BRAND_MONITORING__TONALITY__POSITIVE',
    [AiMonitoringTonalityEnum.neutral]: 'AI_BRAND_MONITORING__TONALITY__NEUTRAL',
    [AiMonitoringTonalityEnum.mixed]: 'AI_BRAND_MONITORING__TONALITY__MIXED',
    [AiMonitoringTonalityEnum.negative]: 'AI_BRAND_MONITORING__TONALITY__NEGATIVE',
};

export const TONALITY_TAG_COLOR_MAP: Record<AiMonitoringTonalityEnum, TagProps['color']> = {
    [AiMonitoringTonalityEnum.positive]: 'green',
    [AiMonitoringTonalityEnum.neutral]: 'default',
    [AiMonitoringTonalityEnum.mixed]: 'orange',
    [AiMonitoringTonalityEnum.negative]: 'red',
};
